import { useEffect, useState } from 'react';
import POSTER from '../assets/images/hero-gurugram-nuh.webp';
import VIDEO from '../assets/images/hero-gurugram-nuh.mp4';

/** Plays the video only when motion is welcome and the visitor isn't saving data. */
function useVideoAllowed() {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = navigator.connection?.saveData === true;
    const update = () => setAllowed(!query.matches && !saveData);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);

  return allowed;
}

/**
 * Full-page background, fixed behind the hero and form. Decorative.
 * The photograph is always rendered underneath: it shows while the video loads,
 * if it fails, and for reduced-motion visitors. The video fades in once playing.
 */
export default function PageBackdrop() {
  const videoAllowed = useVideoAllowed();
  const [imageFailed, setImageFailed] = useState(false);
  const [videoFailed, setVideoFailed] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);

  return (
    <div className="backdrop" aria-hidden="true">
      <div className="backdrop__layer">
        {!imageFailed && (
          <img
            className="backdrop__media"
            src={POSTER}
            alt=""
            width="1672"
            height="941"
            decoding="async"
            fetchpriority="high"
            onError={() => setImageFailed(true)}
          />
        )}
        {videoAllowed && !videoFailed && (
          <video
            className={`backdrop__media backdrop__video${videoPlaying ? ' is-playing' : ''}`}
            src={VIDEO}
            poster={POSTER}
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            disablePictureInPicture
            tabIndex={-1}
            onPlaying={() => setVideoPlaying(true)}
            onError={() => setVideoFailed(true)}
          />
        )}
      </div>
      <div className="backdrop__scrim" />
    </div>
  );
}
